<template>
    <div class="@container/tone">
        <div :id="voiceLabelId" class="text-slate-700 text-base font-bold">Voice</div>

        <vx-radio-selection
            :modelValue="props.modelValue"
            class="mt-4 grid gap-2 grid-cols-2 @lg/tone:grid-cols-4"
            :aria-labelledby="voiceLabelId"
            @update:modelValue="emit('update:modelValue', $event)"
        >
            <vx-radio-selection-item value="friendly" data-test="tone-friendly">Friendly</vx-radio-selection-item>
            <vx-radio-selection-item value="formal" data-test="tone-formal">Formal</vx-radio-selection-item>
            <vx-radio-selection-item value="casual" data-test="tone-casual">Casual</vx-radio-selection-item>
            <vx-radio-selection-item value="funny" data-test="tone-funny">Funny</vx-radio-selection-item>
        </vx-radio-selection>
        <div v-if="props.error" class="mt-1 px-0.5 text-xs text-rose-800">{{ props.error }}</div>
    </div>
</template>

<script setup>
import { VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import { useId } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
    },
    error: {
        type: String,
        default: undefined,
    },
});

const emit = defineEmits(['update:modelValue']);

const voiceLabelId = useId();
</script>
